var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import { parseHostname } from '@ta-interaktiv/parse-hostname';
import { json } from 'd3-request';
import { PureCopyrightNotice } from './pureCopyrightNotice';

/**
 * The subdomain under which to find the API.
 * @type {string}
 * @private
 */
var apiSubdomain = 'mobile2';

/**
 * The endpoint where the media information is stored.
 * @type {string}
 * @private
 */
var apiEndpoint = '/api/external_services';

var LOADING_STATE = 'loading';
var ERROR_STATE = 'error';
var READY_STATE = 'ready';

/**
 * Displays a copyright notice with the correct icon and media name based on the host name.
 *
 * @example
 * import CopyrightNotice from '@ta-interaktiv/react-copyright-notice'
 *
 * function Example(props) {
 *   return (
 *     <CopyrightNotice />
 *   )
 * }
 *
 * @param {object} props
 * @param {boolean} [props.inverted=false] Should the copyright noticed be
 * displayed on a dark background?
 * @param {number} [props.year=<current year>] The year that should be shown
 */
export var PolymorphicCopyrightNotice = function (_React$Component) {
  _inherits(PolymorphicCopyrightNotice, _React$Component);

  function PolymorphicCopyrightNotice() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PolymorphicCopyrightNotice);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PolymorphicCopyrightNotice.__proto__ || Object.getPrototypeOf(PolymorphicCopyrightNotice)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      retrieval: LOADING_STATE
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PolymorphicCopyrightNotice, [{
    key: 'render',
    value: function render() {
      // Don't show anything while we load data or an error occurred
      if (this.state.retrieval === LOADING_STATE || this.state.retrieval === ERROR_STATE) {
        return null;
      }

      // Otherwise display a copyright notice with the correct configurations
      return React.createElement(PureCopyrightNotice, _extends({}, this.state.mediaConfigs, this.props));
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      // handle development
      if (process.env.NODE_ENV === 'development') {
        // no point in doing the round trip to the external services API
        this.setState({
          mediaConfigs: {
            name: 'Local Host',
            secondLevelDomainName: 'localhost'
          },
          retrieval: READY_STATE
        });
        return;
      }

      // parse the current location so we know our second level domain name
      var parsedHostname = parseHostname();

      json('//' + apiSubdomain + '.' + parsedHostname.publicationDomain + apiEndpoint, function (error, externalServicesInformation) {
        // region Error handling
        if (error) {
          console.group('Polymorphic Copyright Notice');
          console.warn('The external services endpoint could not be reached (or threw up for some other reason).');
          console.groupEnd();
          _this2.setState({
            retrieval: ERROR_STATE
          });
          return;
        }
        // endregion

        _this2.setState({
          mediaConfigs: _extends({}, externalServicesInformation.configs, {
            secondLevelDomainName: parsedHostname.publicationName
          }),
          retrieval: READY_STATE
        });
      });
    }
  }]);

  return PolymorphicCopyrightNotice;
}(React.Component);

PolymorphicCopyrightNotice.defaultProps = {
  inverted: false,
  year: new Date(Date.now()).getFullYear()
};
export default PolymorphicCopyrightNotice;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ta-interaktiv/react-copyright-notice/es/polymorphicCopyrightNotice.js
// module id = null
// module chunks = 